import * as PIXI from 'pixi.js';
import { AbstractWheel } from './../spinners/AbstractWheel'
import App from '../App';
export class SimpleWheel extends AbstractWheel {
    constructor() {
        super();
    }
}